var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.592 14.032H21.944V9.616H13.592V0.448H8.744V9.616H0.392V14.032H8.744V23.536H13.592V14.032Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"22","height":"24","viewBox":"0 0 22 24","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
